<template>
  <div class="item">
    <img
      :src="require(`@/assets/image/chaozhilibao/${type > 2 ? 0 : type}.webp`)"
      class="bg"
    />
    <div class="content">
      <div class="title">
        <div class="title_l" :class="`title_l_${type}`">{{ itemData.bundleName }}</div>
        <img class="icon" src="@/assets/image/chaozhilibao/on.webp" v-show="isActive" />
        <img class="icon" src="@/assets/image/chaozhilibao/off.webp" v-show="!isActive" />
      </div>
      <div class="desc">有效期一年</div>
      <div class="line" v-for="item in itemData.voucherTemplates" :key="item.templateId">
        <div class="label">{{ EnumRender(item.type,voucherTypeData) }}</div>
        <div class="value">{{item.amount}}元*{{item.count}}张</div>
      </div>
      <div class="num">¥{{ itemData.price | priceFormat }}</div>
    </div>
  </div>
</template>

<script>
import selectData from '@/mixins/selectData';
export default {
  mixins:[selectData],
  props: {
    itemData: {
      type: Object,
      default: () => ({}),
    },
    type: {
      type: Number,
      default: 0,
    },
    isActive: {
      type: Boolean,
      default: false,
    },
  },
  components: {},
  data() {
    return {};
  },
  created() {},
  computed: {},
  methods: {},
};
</script>

<style scoped lang="scss">
$width: 256px;
$height: 236px;
.item {
  width: $width;
  height: $height;
  position: relative;
  .bg {
    width: $width;
    height: $height;

    position: absolute;
    inset: 0;
    filter: drop-shadow(0px 6px 6px rgba(42, 84, 193,0.2));
    pointer-events: none;
    z-index: 0;
  }
  .content {
    position: relative;
    z-index: 1;
    padding: 0 38px;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-top: 20px;
    .title {
      display: flex;
      align-items: center;
      width: 100%;
      justify-content: space-between;
      &_l {
        font-family: "Noto Sans SC";
        font-size: 20px;
        font-weight: bold;
        line-height: normal;
        letter-spacing: 0em;

        font-variation-settings: "opsz" auto;
        font-feature-settings: "kern" on;
        color: #262626;
        &_1{
          color: #2473F5;
        }
        &_2{
          color: #9A31F3;
        }
      }
      .icon {
        width: 16px;
        height: 16px;
      }
    }
    .desc {
      font-family: "Noto Sans SC";
      font-size: 12px;
      font-weight: normal;
      line-height: normal;
      letter-spacing: 0em;

      font-variation-settings: "opsz" auto;
      font-feature-settings: "kern" on;
      color: #666666;
      width: 100%;
      margin-top: 2px;
      margin-bottom: 10px;
    }
    .line {
      display: flex;
      margin-top: 6px;
      width: 100%;
      justify-content: space-between;
      align-items: center;
      .label {
        font-family: "Noto Sans SC";
        font-size: 14px;
        font-weight: normal;
        line-height: normal;
        letter-spacing: 0em;

        color: #262626;
      }
      .value {
        font-family: "Noto Sans SC";
        font-size: 14px;
        font-weight: 500;
        line-height: normal;
        letter-spacing: 0em;

        font-variation-settings: "opsz" auto;
        color: #ff4544;
      }
    }
    .num {
      font-family: "Noto Sans SC";
      font-size: 30px;
      font-weight: bold;
      line-height: normal;
      display: flex;
      align-items: center;
      letter-spacing: 0em;

      font-variation-settings: "opsz" auto;
      background: linear-gradient(180deg, #ffffff 25%, #fff7aa 90%);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      background-clip: text;
      text-fill-color: transparent;
      margin-top: 39px;
    }
  }
}
</style>
